import { render } from "./ShowMailTest.vue?vue&type=template&id=298446de&scoped=true"
import script from "./ShowMailTest.vue?vue&type=script&lang=js"
export * from "./ShowMailTest.vue?vue&type=script&lang=js"

import "./ShowMailTest.vue?vue&type=style&index=0&id=298446de&lang=sass&scoped=true"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298446de"]])

export default __exports__